import { useEffect } from "react";
import { trackEvent } from "../tracking";

export default function CharlotteSpecialRam({ source = "organic" }) {
  useEffect(() => {
    const s = document.createElement("script");
    s.src = "https://tally.so/widgets/embed.js";
    s.async = true;
    document.body.appendChild(s);
    return () => document.body.removeChild(s);
  }, []);

  useEffect(() => {
    trackEvent(`Charlotte_PageView`, {
      content_name: `charlotte_${source}`,
      content_category: "charlotte_event",
    });
  }, [source]);

  return (
    <div style={{ position: "fixed", inset: 0, overflow: "hidden", margin: 0 }}>
      <iframe
        data-tally-src="https://tally.so/r/RGZPQp?transparentBackground=1&formEventsForwarding=1"
        width="100%"
        height="100%"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="Ram Miriyala"
        style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, border: 0 }}
      />
    </div>
  );
}
